import { render, staticRenderFns } from "./GreyRectangle.vue?vue&type=template&id=9bbc0556&scoped=true&"
import script from "./GreyRectangle.vue?vue&type=script&lang=js&"
export * from "./GreyRectangle.vue?vue&type=script&lang=js&"
import style0 from "./GreyRectangle.vue?vue&type=style&index=0&id=9bbc0556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbc0556",
  null
  
)

export default component.exports